import { Injectable } from '@angular/core';


function getWindow (): any {
  return window;
}

@Injectable()
export class WindowsRefService {
  get nativeWindow (): any {
      return getWindow();
  }
}
